export default "__VITE_ASSET__b1aeecdb__"